import { lazy } from 'react';

// Types
import { SavedCollectionPointsModalProps as LazyComponentProps } from './SavedCollectionPointsModal.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "savedCollectionPointsModal" */ './SavedCollectionPointsModal')),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'SavedCollectionPointsModal');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as SavedCollectionPointsModal };
